"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var CouponLadderMobile_1 = __importDefault(require("./CouponLadderMobile"));
var Discount_1 = __importDefault(require("./Discount"));
var TextBtn_1 = __importDefault(require("./TextBtn"));
// 右侧卡券折扣的最大数量
var MAX_CARD_LEN = 3;
function CouponLadder(props) {
    var className = props.className, style = props.style, title = props.title, describe = props.describe, rule = props.rule, buttonText = props.buttonText, couponList = props.couponList, theme = props.theme;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var themeClass = theme ? "coupon-ladder-".concat(theme) : '';
    var cardLen = couponList.length;
    /**
     * 渲染卡券右侧折扣列表
     * @param item 卡券右侧list数据
     * @param index map循环的index
     */
    function renderCouponCard(item, index) {
        // 限制卡券折扣的最大数量
        if (index > MAX_CARD_LEN) {
            return null;
        }
        return react_1.default.createElement(Discount_1.default, __assign({ key: "card-".concat(index) }, item));
    }
    /**
     * 渲染卡券左下区域按钮
     */
    function renderButton() {
        if (!buttonText) {
            return null;
        }
        return react_1.default.createElement("button", { className: "coupon-ladder-button" }, buttonText);
    }
    /**
     * 渲染卡券左上区域，title，describe，rule
     */
    function renderLeftHeader() {
        return (react_1.default.createElement("div", { className: "left-header" },
            react_1.default.createElement("div", { className: "header" },
                react_1.default.createElement("span", { className: "header-title" }, title),
                rule && react_1.default.createElement(TextBtn_1.default, __assign({}, rule))),
            react_1.default.createElement("div", { className: "desc" }, describe)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)(className, "".concat(classPrefix, "-coupon-ladder"), themeClass) },
            react_1.default.createElement("div", { className: "coupon-ladder-left" },
                renderLeftHeader(),
                renderButton()),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('coupon-ladder-right', "base-card-".concat(cardLen)) }, couponList.map(renderCouponCard))),
        react_1.default.createElement(CouponLadderMobile_1.default, __assign({}, props))));
}
exports.default = CouponLadder;
//# sourceMappingURL=CouponLadder.js.map